var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "media-list__item media-list__item-pdf" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }